/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import useClassNames from '@medflex/hooks/useClassNames';
import Portal from '../Portal';
import TooltipContext from './TooltipContext';
import TooltipArrow from './TooltipArrow';

const Tooltip = ({ children, className, ...props }) => {
  const { isVisible, triggerRef, tooltipRef, popperStyle, hide, placement } =
    useContext(TooltipContext);

  const cn = useClassNames(
    () => [
      'relative',
      'px-4',
      'py-2',
      'text-white',
      'rounded',
      'text-sm',
      'shadow-lg',
      'bg-slate-800',
      className,
      placement.indexOf('top') !== -1 && 'mb-3',
      placement.indexOf('right') !== -1 && 'ml-3',
      placement.indexOf('bottom') !== -1 && 'mt-3',
      placement.indexOf('left') !== -1 && 'mr-3',
    ],
    [className, placement],
  );

  useEffect(() => {
    if (isVisible && triggerRef.current && tooltipRef.current) {
      const handleMouseEvent = e => {
        if (
          triggerRef.current &&
          !triggerRef.current.contains(e.target) &&
          tooltipRef.current &&
          !tooltipRef.current.contains(e.target)
        ) {
          hide();
        }
      };
      const handleClick = e => {
        if (triggerRef.current && triggerRef.current.contains(e.target)) {
          hide();
        }
      };
      document.addEventListener('mouseover', handleMouseEvent);
      document.addEventListener('click', handleClick);
      return () => {
        document.removeEventListener('mouseover', handleMouseEvent);
        document.removeEventListener('click', handleClick);
      };
    }
  }, [isVisible, triggerRef, tooltipRef]);

  if (!isVisible) return null;

  return (
    <Portal>
      <div
        data-component="Tooltip"
        className="select-none z-100"
        ref={tooltipRef}
        style={{ ...popperStyle }}
        {...props}
      >
        <div className={cn}>
          <TooltipArrow />
          <TooltipContext.Consumer>
            {typeof children === 'function' ? children : () => children}
          </TooltipContext.Consumer>
        </div>
      </div>
    </Portal>
  );
};

Tooltip.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.string]).isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default Tooltip;
